import React from 'react'
import { AiOutlinePlus } from "react-icons/ai";
import { CgChevronLeft, CgChevronRight } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap'

const PageBanner = ({ modal, setModal, title, description, buttonText }) => {
    const navigation = useNavigate()

    return (
        <Row className='mt-3 '>
            <Col md={5} className='mb-3'>
                <div><strong className='f18 color1 fw600'>{title}</strong></div>
                <div><span className='f14 color2 fw400'>{description}</span></div>
            </Col>
            <Col md={7} className='d-flex justify-content-end align-items-center'>
                <div>
                    <Button
                        className='bg-transparent border text-primary rounded h40px'
                        onClick={() => navigation(-1)}
                    >
                        <CgChevronLeft size={20} />
                    </Button>
                </div>
                {buttonText ? <div className='mx-2'>
                    <Button
                        className='pb border-0 text-white br10 h40px d-flex align-items-center'
                        onClick={() => setModal(!modal)}
                    >
                        <span className='f14 fw500 mr-2'>{buttonText}</span>
                        <AiOutlinePlus size={15} />
                    </Button>
                </div> : null}
                <div>
                    <Button
                        className='bg-transparent border text-primary rounded h40px'
                        onClick={() => navigation(+1)}
                    >
                        <CgChevronRight size={20} />
                    </Button>
                </div>
            </Col>
        </Row>
    )
}

export default PageBanner
